import { Skeleton } from '../skeleton';
import { TableCell, TableRow } from '../table';

type TableSkeletonRowProps = {
  columns: Array<{ width?: string; basis?: string; flexGrow?: number }>;
  // Shared row floor (px string) so the skeleton matches the real rows'
  // width inside a scrollable table.
  minWidth?: string;
};

export const TableSkeletonRow = ({
  columns,
  minWidth,
}: TableSkeletonRowProps) => (
  <TableRow minWidth={minWidth}>
    {columns.map((col, i) => (
      <TableCell basis={col.basis} flexGrow={col.flexGrow} key={i}>
        <Skeleton width={col.width ?? '60%'} />
      </TableCell>
    ))}
  </TableRow>
);
